import { OfflineRequestsScreen } from 'pages/OfflineRequests/OfflineRequestsScreen';

import { Shifts, TaskArch, TaskDetail, TaskList } from '../../pages';

export const routingTask = [
  {
    path: '/',
    exact: true,
    component: TaskList,
    claims: ['CanLookTaskSection'],
  },
  {
    path: '/task',
    exact: true,
    component: TaskList,
    claims: ['CanLookTaskSection'],
  },
  {
    path: '/task/detail-arch/:id',
    exact: true,
    component: TaskDetail,
    claims: ['CanLookTaskSection'],
  },
  {
    path: '/task/detail/:id',
    exact: true,
    component: TaskDetail,
    claims: ['CanLookTaskSection'],
  },
  {
    path: '/task/add',
    exact: true,
    component: TaskDetail,
    claims: ['CanEditRequest'],
  },
  {
    path: '/shift',
    exact: true,
    component: Shifts,
    claims: ['CanLookTaskSection'],
  },
  {
    path: '/task-arch',
    exact: true,
    component: TaskArch,
    claims: ['CanLookTaskSection'],
  },
  {
    path: '/offline-requests',
    exact: true,
    component: OfflineRequestsScreen,
    claims: ['CanSeeOfflineRequestWorks'],
  },
];
